import { Message } from '../../graphql/chat';

interface SystemMessageProps {
  message: Message;
}

export function SystemMessage({ message }: SystemMessageProps) {
  // Format timestamp
  const formatTime = (timestamp: string) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;

    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours}h ago`;

    return date.toLocaleDateString();
  };

  return (
    <div className="flex justify-center">
      <div className="bg-[#2c2c2c] border border-gray-700 rounded-lg px-4 py-2 max-w-[90%]">
        <div className="flex items-start gap-2">
          <span className="text-lg flex-shrink-0">⚡</span>
          <div className="flex-1 min-w-0">
            <p className="text-sm text-gray-300 break-words">{message.content}</p>
            <span className="text-xs text-gray-500 mt-1 block">
              {formatTime(message.timestamp)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
